module.exports = __webpack_public_path__ + "img/locked-folder.cd2925a1.jpg";